import { render, staticRenderFns } from "./putInSuc.vue?vue&type=template&id=5910f79a&scoped=true&"
import script from "./putInSuc.vue?vue&type=script&lang=js&"
export * from "./putInSuc.vue?vue&type=script&lang=js&"
import style1 from "./putInSuc.vue?vue&type=style&index=1&id=5910f79a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5910f79a",
  null
  
)

export default component.exports